import { Stack, styled } from 'shell/components';
import { HugoPanelTransitionMs, LauncherHeightPx, LauncherRightOffsetPx, LauncherWidthPx } from './constants';

export const HugoPanelShell = styled(Stack)(() => {
    return {
        position: 'relative',
        flex: 1,
        width: '100%',
        minWidth: 0,
        minHeight: 0,
        overflow: 'hidden',
    };
});

const HugoPanelFrame = styled('aside', {
    shouldForwardProp: (prop) => !['isFullScreen', 'isVisible', 'launcherVerticalPosition'].includes(prop),
})(({ isFullScreen, isVisible, launcherVerticalPosition, theme }) => {
    const expandedWidth = isFullScreen ? 'min(1200px, calc(100vw - 48px))' : 'min(444px, calc(100vw - 32px))';
    const expandedHeight = isFullScreen ? 'calc(100vh - 48px)' : 'min(720px, calc(100vh - 120px))';
    const expandedTop = isFullScreen ? theme.spacing(3) : `calc(100vh - ${expandedHeight} - ${theme.spacing(3)})`;
    const expandedRight = isFullScreen ? `max(${theme.spacing(3)}, calc((100vw - 1200px) / 2))` : theme.spacing(6);

    return {
        position: 'fixed',
        top: isVisible ? expandedTop : `${launcherVerticalPosition}px`,
        right: isVisible ? expandedRight : `${LauncherRightOffsetPx}px`,
        zIndex: theme.zIndex.drawer + 2,
        width: isVisible ? expandedWidth : `${LauncherWidthPx}px`,
        height: isVisible ? expandedHeight : `${LauncherHeightPx}px`,
        minHeight: isVisible ? '420px' : `${LauncherHeightPx}px`,
        border: `1px solid ${theme.palette.ensightful.neutral[200]}`,
        borderRadius: isFullScreen ? '12px' : '20px',
        background: theme.palette.ensightful.shades[0],
        boxShadow: theme.palette.ensightful.shadows[2],
        display: 'flex',
        overflow: 'hidden',
        opacity: isVisible ? 1 : 0.75,
        pointerEvents: isVisible ? 'auto' : 'none',
        transformOrigin: 'right center',
        transition: theme.transitions.create(
            ['top', 'right', 'width', 'height', 'min-height', 'border-radius', 'opacity'],
            {
                duration: HugoPanelTransitionMs,
                easing: theme.transitions.easing.easeInOut,
            }
        ),
        willChange: 'top, right, width, height, opacity',

        '&:focus-visible': {
            outline: 'none',
        },

        '@media (prefers-reduced-motion: reduce)': {
            transition: 'none',
            willChange: 'auto',
        },

        [theme.breakpoints.down('tablet')]: {
            right: isVisible ? (isFullScreen ? theme.spacing(3) : theme.spacing(1.5)) : `${LauncherRightOffsetPx}px`,
            width: isVisible ? (isFullScreen ? 'calc(100vw - 24px)' : 'calc(100vw - 12px)') : `${LauncherWidthPx}px`,
        },
    };
});

export default HugoPanelFrame;
